// @flow
import { APICore } from './apiCore';
import config from '../../config';
import { PAGINATION_DEFAULT_VALUE } from '../defaultValue';

const api = new APICore();

const buildJobsUrl = () => {
    if (config.JOBS_URL) {
        return config.JOBS_URL;
    }
    if (config.API_BASE_URL) {
        return `${config.API_BASE_URL.replace(/\/$/, '')}/v1/jobs`;
    }
    return undefined;
};

const BASE_URL = buildJobsUrl();

type JobsQuery = {
    page?: number,
    pageSize?: number,
    sortBy?: string,
    status?: string,
    jobType?: string,
    integrationId?: string,
};

function getJobs(query: JobsQuery = {}): any {
    if (!BASE_URL) {
        return Promise.reject({ errors: [{ type: 'system', message: 'Jobs URL is not configured' }] });
    }
    const page = query?.page ?? PAGINATION_DEFAULT_VALUE.currentPage ?? 0;
    const pageSize = query?.pageSize ?? PAGINATION_DEFAULT_VALUE.pageSize ?? 50;

    const params: any = {
        page: page.toString(),
        page_size: pageSize.toString(),
        sort_by: query?.sortBy ?? 'updatedAtDesc',
    };

    if (query?.status) {
        params.status = query.status;
    }
    if (query?.jobType) {
        params.jobType = query.jobType;
    }
    if (query?.integrationId) {
        params.integrationId = query.integrationId;
    }

    return api.get(`${BASE_URL}`, params, { headers: { 'full-response': true } });
}

export { getJobs, buildJobsUrl };
